var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.199,
    height: 9.594,
    viewBox: "0 0 13.199 9.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M31.675,28.859l-.428.414c-2.034,1.973-4.224,4.248-6.257,6.239L22,33.126l-.465-.371-.767.907.465.371,3.421,2.727.421.335.39-.377c2.158-2.094,4.506-4.552,6.64-6.622l.428-.414Z",
    transform: "translate(-20.051 -28.164)",
    fill: "#9b9b9b",
    stroke: "#108757",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3e66ce19b72cacafeb0271a4ea56bd87.svg";
export { ForwardRef as ReactComponent };